import { useParams } from 'react-router-dom';
import { WorldViewer } from './WorldViewer';
import Cookies from 'js-cookie';

export const WorldEmbedded = () => {
    const { zone } = useParams<{ zone: string }>();
    const searchParams = new URLSearchParams(window.location.search);
    const appliedFlag = searchParams.get('applied') === 'true';

    if (!zone) {
        return null;
    }

    const project = Cookies.get('project') || "default";

    return (
        <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
            <WorldViewer project={project} zone={zone} applied={appliedFlag} />
        </div>
    );
}